<template>
  <el-dialog title="上传合同凭证" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
             :visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog" width="90%"
             style="position: absolute; top: -40px;background-color: rgb(38 38 38 / 70%);" @close="dialogClose"
             v-el-drag-dialog
             v-el-dialog-center>
    <template>
      <div id="containt">
        <div style="height: 300px;display: flex;    justify-content: space-between;">
          <!-- <el-upload style="width: 5%;" :action="api.uploadFileUrl" :headers="headers" accept=".mp4,.m4a,.aac"
                 :on-preview="handlePictureCardPreview2" :on-success="uploadPictureSuccess"
                 :show-file-list="true" :on-remove="handleRemoveVideo" :on-change="uploadPictureChange" :on-progress="upVideo"
                 list-type="picture-card" class="videoUpload">
        <i class="el-icon-plus"></i>
      </el-upload> -->
<!--          <el-upload accept=".doc,.docx,.xlsx,.xls,.ppt,.pptx,.pdf,.txt"-->
          <el-upload style="width: 5%;"
                     :action="api.uploadFileUrl"
                     :headers="headers"
                     :on-preview="handlePictureCardPreview2"
                     :on-success="uploadPictureSuccess" :show-file-list="true" :on-remove="handleRemoveVideo"
                     :on-change="uploadPictureChange" :on-progress="upVideo" list-type="picture-card"
                     class="videoUpload">
            <i slot="default" class="el-icon-plus"></i>
          </el-upload>
          <div style="width: 90%;display: flex;margin-top: 40px;flex-wrap: wrap;">
            <div v-for="(item, index) in videoList" :key="index" class="videoP">
              <div style="display: flex; flex-wrap: wrap;">
                <div style="width:30%;    position: relative;" class="videoImg">
                  <el-image style="width: 50px; height: 60px" :src="require('@/views/dialogCommon/htpz.jpg')" fit="fit">
                  </el-image>
                  <div @click="() => {showPreview = true; previewFileUrl = item.url}" class="imgY"><i
                    class="el-icon-tickets"></i></div>
                </div>
                <div
                  style="width:70%;display:flex;    flex-direction: column;justify-content: space-between;align-items: flex-end;">
                  <span style="width: 70%; height: 70%; overflow: hidden;">
                    {{ item.name.length > 8 ? item.name.slice(0, 7) + '...' : item.name }}
                  </span>
                  <div @click="handleDownload(item.name, item.url)">
                    <el-tooltip class="item" effect="dark" content="下载" placement="top">
                      <i class="el-icon-download"></i>
                    </el-tooltip>
                  </div>
                </div>
              </div>
              <i @click="deleteT(item,index)" class="el-icon-circle-close"></i>
            </div>
          </div>
        </div>
      </div>
    </template>
    <span slot="footer" class="dialog-footer">
      <!--			<span class="fl tips" v-if="!selectMulti">注：双击确认选择（单选）</span>-->
      <el-button type="primary" plain class="button-sty" @click="dialogClose">
        <i class="el-icon-close el-icon"></i>
        取 消
      </el-button>
      <el-button type="primary" @click="commitRow" class="button-sty">
        <i class="el-icon-check el-icon"></i>
        确 定
      </el-button>
    </span>

    <!-- 文件预览 -->
    <Preview v-if="showPreview"
             @closeD="() => {showPreview = false; previewFileUrl = null}"
             :visiable.sync="showPreview"
             :imgVisbleURL="previewFileUrl"
    />
  </el-dialog>


</template>

<script>
import {selectDialogMixins} from '@/mixins/selectDialog/index.js';
import {initVxeTable} from '@/const/crud/admin/table'

import store from "@/store";

import api from "@/api/projectApi";
import Preview from "@/views/dialogCommon/PreviewDialog.vue";

export default {
  name: 'saleConfigDialog',
  components: {Preview},
  props: ['visiable', 'multi', 'param', 'excludeId', 'siteFloorLevel', 'orgId', 'companyId', 'isWithoutEnd'],
  mixins: [selectDialogMixins],
  computed: {

    api() {
      return api
    },
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      };
    }

  },
  watch: {
    photoUrl: {
      handler(url) {
        if (url) {
          let list = []
          if (url !== null && url !== '' && url !== undefined) {
            this.videoUrl2 = url,
              console.log(url, "name55555");

          }


        } else {

        }
      },
      deep: true,
      immediate: false,
    },

    videoList: {
      handler(n) {
        if (n.length > 0) {
          console.log(this.videoList, n, "触发l此处");
          this.$emit('update:photoUrl', this.videoList)
        }
      },
      deep: true,
      immediate: false,
    },

  },
  created() {

  },


  data() {
    return {
      showPreview: false,
      previewFileUrl: null,


      videoList: [],

      total: 0,
      filterText: '',
      data: [],

      pageSizes: [10, 20, 100],
      //以上树形
      activeName: 'second',
      dataId: 0,
      showEdit: false,
      vxeOption: {},
      isRouterAlive: true,
      // 查询参数
      formData: {
        vedioUrl: '',
        vedioName: ""
      },
      showDialog: true,
      falseValue: false,
      selectMulti: true,
      searchSiteName: '',
      searchSiteAccount: null,
      selectedRow: {
        id: '', name: '', orgId: null, orgIdPath: null
      }
    };
  },


  methods: {
    deleteT(e){
      let temp=[]
      temp.push(e)
      console.log(temp,"temp的元素");
      if (temp=== undefined || temp.length === 0) {
        this.$message.warning('请先选择文件')
      } else {
        this.$baseConfirm('您确定要删除吗？').then(() => {
          temp.forEach(item => {
            this.videoList = this.videoList.filter(item1 => item1.url !== item.url)
          })
         temp = []
        })
      }

    },
    // 文件下载
    handleDownload(Vname, Vurl) {
      this.$mask.open()

      console.log(Vname, Vurl, "视频下载");
      // let url=file.type
      let url = Vurl
      let name = Vname

      const x = new XMLHttpRequest()
      x.open('GET', url, true)
      x.responseType = 'blob'
      x.onload = function () {
        const url = window.URL.createObjectURL(x.response)
        const a = document.createElement('a')
        a.href = url
        a.download = name
        a.click()
      }
      x.send()
      this.$mask.close()


      // window.open(url,'_blank');
    },
    // 预览
    openVideo(value) {
      let host = window.location.hostname
      console.log(host, "域名111");

      let url = `https://` + host + value
      console.log(url, "url 名字");
      window.open("https://view.xdocin.com/view?src=" + encodeURIComponent(url));


      // window.open(this.formData.vedioUrl, '_blank')
    },
    handleRemoveVideo(file, fileList) {
      this.hideUpload = fileList.length >= this.limitCount;

      console.log(file, fileList, "151");
      // 调删除图片接口
      // deleteFileByName({ fileName: this.form.url }).then(res => {
      //   if (res.code == 200) {
      //     // this.form.url = ''
      //     // this.form.time = ''
      //     this.$message({
      //       message: res.msg,
      //       type: 'success'
      //     });
      //     this.isShow = false
      //   }
      // })

    },
    upVideo() {
      this.$mask.open()

    },
    handleRemoveVideo(file, fileList) {
      this.hideUpload = fileList.length >= this.limitCount;

      console.log(file, fileList);
      // 调删除图片接口
      // deleteFileByName({ fileName: this.form.url }).then(res => {
      //   if (res.code == 200) {
      //     // this.form.url = ''
      //     // this.form.time = ''
      //     this.$message({
      //       message: res.msg,
      //       type: 'success'
      //     });
      //     this.isShow = false
      //   }
      // })

    },
    // 视频
    handlePictureCardPreview2(file) {
      console.log(file, file.url, "99999")
      // this.videoUrl = file.url;

    },
    uploadPictureSuccess(res, file) {
      if (file.status == "success") {
        this.$message({
          message: '文件上传成功',
          type: 'success'
        });
        this.$mask.close()

        console.log(res, file, '上传成功后的res视频');
        this.videoList.push({name: file.name, url: res.data.url});
        console.log(this.videoList, "上传的视频1111");

      }
      this.isShow = true;
      this.$emit('update:photoUrl', this.videoList); // 触发更新 photoUrl 的事件
    },
    uploadPictureChange(file, fileList) {
      console.log(file, fileList)
      let _this = this
      // this.hideUpload = fileList.length >= this.limitCount;
      var audioElement = new Audio(file.url), duration;
      audioElement.addEventListener("loadedmetadata", function () {
        // _this.form.time = audioElement.duration;
        // console.log('时长：' + _this.form.time + 's')
      })
    },


    commitRow() {
      if (this.videoList !== '') {
        this.$emit('commitVideo', this.videoList)
        this.dialogClose()
      } else {
        this.$message.warning('请先上传视频')
      }
    },

  }
};
</script>
<style lang="scss" scoped>
// 装图片的  大框
::v-deep .el-upload--picture-card {
  margin: 20px 10px;
  width: 70px;
  height: 70px;
  line-height: 70px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  // display:none;
  width: 0px;
  height: 0px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 60px;
  height: 60px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}

::v-deep .avatar2 {
  position: absolute;
  width: 130px;
  height: 70px;
  top: 40px;
  left: 100px;
}


.videoAdd {
  width: 40px;
  height: 40px;
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  text-align: center;
  line-height: 40px;

}

.videoP {
  margin-left: 10px;
  margin-bottom: 10px;
  padding: 5px;
  border: 1px solid #e8e8e8;
  width: 200px;
  height: 70px;

  border-radius: 3px;
}

.imgY {
  position: absolute;
  height: 60px;
  width: 50px;
  top: 0px;
  line-height: 60px;
  left: 2px;
  background-color: #c6c2c2;
  opacity: 0.9;
  text-align: center;
  line-height: 60px;
  font-size: 30px;
  display: none;
}

.videoImg:hover .imgY {

  display: block
}
</style>
